import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-account\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><g stroke=\"currentColor\" stroke-width=\"1.5\"><path d=\"M4.5 5h10a1 1 0 0 1 1 1v2h-12V6a1 1 0 0 1 1-1zm12 7.5h4v3h-4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z\" /><path d=\"M3.5 8h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1V8z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol